/**
 * Navegación entre módulos del POS (caja, gastos, pedidos, etc.).
 */

function initModuleNavMenu(win, $) {
	if (win._posknModuleNavBound) return;
	win._posknModuleNavBound = true;

	$(() => {
		$('.menu-btn[data-section]').on('click', function onMenuSectionClick() {
		const section = $(this).data('section');

		$('.menu-btn').removeClass('active');
		$(this).addClass('active');

		switch (section) {
			case 'inicio':
				win.volverInicio();
				break;
			case 'caja':
				win.mostrarModuloCaja();
				break;
			case 'gastos':
				win.mostrarModuloGastos();
				break;
			case 'pedidos':
				win.mostrarModuloPedidos();
				break;
			case 'cierre':
				win.mostrarModuloCierre();
				break;
			case 'inventario':
				win.mostrarModuloInventario();
				break;
			case 'mesas':
				if (win.posknPuedeVerMesas && typeof win.mostrarModuloMesas === 'function') {
					win.mostrarModuloMesas();
				}
				break;
			default:
				break;
		}
		});
	});
}

export function attachModuleNavGlobals(win, $) {
	initModuleNavMenu(win, $);

	// Logout siempre desde el bundle (el script inline puede fallar antes de enlazar el botón).
	if (!win._posknLogoutBound) {
		win._posknLogoutBound = true;
		$(document).on('click', '#cerrar-sesion', (e) => {
			e.preventDefault();
			if (!win.confirm('¿Estás seguro que deseas cerrar sesión?')) return;
			try {
				if (typeof win.limpiarEstadoTurnoCaja === 'function') win.limpiarEstadoTurnoCaja();
				win.localStorage.removeItem('pos_borrador_pedido');
				win.localStorage.removeItem('pos_pedido_enviando');
				win.sessionStorage.clear();
			} catch (err) {
				/* ignore */
			}
			const url =
				win.POSKN_LOGOUT_URL ||
				(typeof win.posknLogoutUrl === 'string' ? win.posknLogoutUrl : '');
			if (!url) {
				if (typeof win.mostrarNotificacion === 'function') {
					win.mostrarNotificacion('No se encontró la URL de cierre de sesión', 'error');
				}
				return;
			}
			win.location.href = url;
		});
	}

	win.volverInicio = function volverInicio() {
		$('.modulo-contenido').hide();
		$('.pos-container').show();
		$('.menu-btn').removeClass('active');
		$('.menu-btn[data-section="inicio"]').addClass('active');
	};

	win.mostrarModuloCaja = function mostrarModuloCaja() {
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-caja').show();
		if (typeof win.cargarEstadoCaja === 'function') win.cargarEstadoCaja();
		if (typeof win.cargarGastosCaja === 'function') win.cargarGastosCaja();
	};

	win.mostrarModuloGastos = function mostrarModuloGastos() {
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-gastos').show();
		if (typeof win.cargarGastos === 'function') win.cargarGastos();
	};

	win.mostrarModuloPedidos = function mostrarModuloPedidos() {
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-pedidos').show();
		if (typeof win.actualizarIndicadorPendientesSubir === 'function') {
			win.actualizarIndicadorPendientesSubir();
		}
		if (typeof win.cargarPedidos === 'function') win.cargarPedidos();
		if (typeof win.cargarProductosVendidosCaja === 'function') win.cargarProductosVendidosCaja();
		if (typeof win.posknStartPedidosPoll === 'function') win.posknStartPedidosPoll();
	};

	win.mostrarModuloCierre = function mostrarModuloCierre() {
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-cierre').show();
		if (typeof win.cargarDatosCierre === 'function') win.cargarDatosCierre();
	};

	win.mostrarModuloInventario = function mostrarModuloInventario() {
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-inventario').show();
		if (typeof win.cargarInventario === 'function') win.cargarInventario();
	};

	win.toggleSeccion = function toggleSeccion(header) {
		const seccion = $(header).closest('.seccion');
		const content = seccion.find('.seccion-content');
		const icon = $(header).find('span').last();

		if (seccion.hasClass('collapsed')) {
			seccion.removeClass('collapsed');
			content.slideDown(200);
			icon.text('▼');
		} else {
			seccion.addClass('collapsed');
			content.slideUp(200);
			icon.text('▶');
		}
	};
}
